import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'or',
  months: [
    'ଜାନୁଆରୀ',
    'ଫେବୃଆରୀ',
    'ମାର୍ଚ',
    'ଏପ୍ରିଲ୍‌',
    'ମେ',
    'ଜୁନ୍‌',
    'ଜୁଲାଇ',
    'ଅଗଷ୍ଟ',
    'ସେପ୍ଟମ୍ୱର୍‌',
    'ଅକ୍ଟୋବର୍‌',
    'ନଭେମ୍ୱର୍‌',
    'ଡିସେମ୍ୱର୍‌',
  ],
  monthsShort: [
    'ଜାନୁଆରୀ',
    'ଫେବ୍ରୁଆରୀ',
    'ମାର୍ଚ୍ଚ',
    'ଏପ୍ରିଲ୍‍',
    'ମେ',
    'ଜୁନ୍',
    'ଜୁଲାଇ',
    'ଅଗଷ୍ଟ',
    'ସେପ୍ଟେମ୍ବର',
    'ଅକ୍ଟୋବର',
    'ନଭେମ୍ବର',
    'ଡିସେମ୍ବର',
  ],
  weekdays: ['ରବିବାର', 'ସୋମବାର', 'ମଙ୍ଗଳବାର', 'ବୁଧବାର', 'ଗୁରୁବାର', 'ଶୁକ୍ରବାର', 'ଶନିବାର'],
  weekdaysMin: ['ରବି', 'ସୋମ', 'ମଙ୍ଗଳ', 'ବୁଧ', 'ଗୁରୁ', 'ଶୁକ୍ର', 'ଶନି'],
  weekdaysShort: ['ରବିବାର', 'ସୋମବାର', 'ମଙ୍ଗଳବାର', 'ବୁଧବାର', 'ଗୁରୁବାର', 'ଶୁକ୍ରବାର', 'ଶନିବାର'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY HH:mm',
    'LLL-Y': 'D MMMM HH:mm',
    LLLL: 'dddd, D MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd, D MMMM HH:mm',
    l: 'D/M/YYYY',
    'l-Y': 'D/M',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    lll: 'D MMM YYYY h:mm A',
    'lll-Y': 'D MMM h:mm A',
    llll: 'ddd, D MMM YYYY h:mm A',
    'llll-Y': 'ddd, D MMM h:mm A',
    'll-Y+w': 'ddd, MMM D',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'MMMM D, YYYY, HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM' },
  past: {
    y: { one: '%s ବ. ପୂର୍ବେ', other: '%s ବ. ପୂର୍ବେ' },
    M: { one: '%s ମା. ପୂର୍ବେ', other: '%s ମା. ପୂର୍ବେ' },
    w: { one: '%s ସପ୍ତା. ପୂର୍ବେ', other: '%s ସପ୍ତା. ପୂର୍ବେ' },
    d: { one: '%s ଦିନ ପୂର୍ବେ', other: '%s ଦିନ ପୂର୍ବେ' },
    h: { one: '%s ଘ. ପୂର୍ବେ', other: '%s ଘ. ପୂର୍ବେ' },
    m: { one: '%s ମି. ପୂର୍ବେ', other: '%s ମି. ପୂର୍ବେ' },
    s: { one: '%s ସେ. ପୂର୍ବେ', other: '%s ସେ. ପୂର୍ବେ' },
  },
  future: {
    y: { one: '%s ବ. ରେ', other: '%s ବ. ରେ' },
    M: { one: '%s ମା. ରେ', other: '%s ମା. ରେ' },
    w: { one: '%s ସପ୍ତା. ରେ', other: '%s ସପ୍ତା. ରେ' },
    d: { one: '%s ଦିନରେ', other: '%s ଦିନରେ' },
    h: { one: '%s ଘ. ରେ', other: '%s ଘ. ରେ' },
    m: { one: '%s ମି. ରେ', other: '%s ମି. ରେ' },
    s: { one: '%s ସେ. ରେ', other: '%s ସେ. ରେ' },
  },
  abbr: {
    y: { one: '%sବ.', other: '%sବ.' },
    M: { one: '%sମି', other: '%sମି' },
    w: { one: '%sସ', other: '%sସ' },
    d: { one: '%sଦି', other: '%sଦି' },
    h: { one: '%sଘ', other: '%sଘ' },
    m: { one: '%sମିନିଟ୍‌', other: '%sମିନିଟ୍‌' },
    s: { one: '%sସେ', other: '%sସେ' },
  },
  justNow: 'କେବଳ ବର୍ତ୍ତମାନ',
  yesterday: 'ଗତକାଲି',
  today: 'ଆଜି',
  tomorrow: 'ଆସନ୍ତାକାଲି',
  weekStart: 0,
};
const localeName: LocaleName = 'or';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'am' : 'AM';
    } else {
      return isLowerCase ? 'pm' : 'PM';
    }
  },
};
